import { AppState } from "../reducer";

export const currentPlayer = (state: AppState) => state.player.me;